import { MapCoordsApi } from '@core/api/model/consumption/map-coords-api.model';
import { MapCoords } from '@core/domain/model/consumption/map-coords.model';
import { PortugalMapTopology, SpainMapTopology } from '@core/api/model/consumption/map-topology.model';
import { MapGeometry } from '@core/domain/model/consumption/map-geometry.model';
import { feature } from 'topojson-client';

export class MapMapper {
  static fromApiCoordsToDomain(api: MapCoordsApi[]): MapCoords[] {
    return api.map((value) => ({
      id: `${value.latitud.toString()}_${value.longitud.toString()}`,
      latitude: value.latitud,
      longitude: value.longitud,
      cups: value.cups,
    }));
  }

  static fromSpainProvincesTopologyToGeoJson(topology: SpainMapTopology): MapGeometry {
    return feature(topology, topology.objects.provinces);
  }

  static fromPortugalDistrictsTopologyToGeoJson(topology: PortugalMapTopology): MapGeometry {
    return feature(topology, topology.objects.portugal_districts);
  }
}
